import style from './Panel.module.css';

export const Panel = ({ children }) => {
  return (
    <div className={style.panel}>
      {children}
    </div>
  );
};